import { api } from "@/lib/api";

// Sprint 7 — Notices & 1:1 Chat (polling)
export const NoticesAPI = {
  inbox: (params) => api.get("/notices/inbox", { params }).then((r) => r.data),
  sent: () => api.get("/notices/sent").then((r) => r.data),
  board: (params) => api.get("/notices/board", { params }).then((r) => r.data),
  create: (body) => api.post("/notices", body).then((r) => r.data),
  remove: (id) => api.delete(`/notices/${id}`).then((r) => r.data),
  markRead: (id) => api.post(`/notices/${id}/read`).then((r) => r.data),
  uploadAttachment: (file, onProgress) => {
    const form = new FormData();
    form.append("file", file);
    return api
      .post("/notices/attachments/upload", form, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: onProgress,
      })
      .then((r) => r.data);
  },
  attachmentUrl: (fileId) => {
    const base = process.env.REACT_APP_BACKEND_URL.replace(/\/$/, "");
    return `${base}/api/v1/notices/attachments/${fileId}`;
  },
};

export const ChatAPI = {
  threads: () => api.get("/chat/threads").then((r) => r.data),
  open: (target_user_id) =>
    api.post("/chat/threads", { target_user_id }).then((r) => r.data),
  messages: (tid, since) =>
    api
      .get(`/chat/threads/${tid}/messages`, { params: since ? { since } : undefined })
      .then((r) => r.data),
  send: (tid, body) =>
    api.post(`/chat/threads/${tid}/messages`, { body }).then((r) => r.data),
  directory: (params) => api.get("/chat/users", { params }).then((r) => r.data),
};
